import Cookies from "js-cookie";
import { tryParseJson } from "@common/try-parse-json.js";
var setCookie = function (name, value, options) {
    Cookies.set(name, value, options);
};
var removeCookie = function (name) { return Cookies.remove(name); };
var getCookie = function (name) {
    var data = Cookies.get(name);
    return tryParseJson(data);
};
export { setCookie, removeCookie, getCookie };
